import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class VersionCheckService {

	version_changed$: EventEmitter<boolean> = new EventEmitter<boolean>();
	current_version$: BehaviorSubject<string> = new BehaviorSubject<string>('');

    // this will be replaced by actual hash post-build.js
    private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

    // the new-version hash we have already notified the user about, so we
    // don't re-prompt every poll for a deploy they've already been told about
    private notifiedHash: string = null;

    constructor(private http: HttpClient) {}

    /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 30 minutes
     */
    public initVersionCheck(url, frequency = 1000 * 60 * 30) {
        this.checkVersion(url);
        setInterval(() => {
            this.checkVersion(url);
        }, frequency);
    }

    private checkVersion(url) {
      this.http.get(url + '?t=' + new Date().getTime()).pipe(
        first()
      ).subscribe(
        (response: any) => {
          const hash = response.hash;
          const version = response.version;

          if (version && this.current_version$.value !== version) {
            this.current_version$.next(version);
          }

          const hashChanged = this.hasHashChanged(this.currentHash, hash);

          if (hashChanged) {
            // Do not advance currentHash — only a full page reload should clear
            // the mismatch. But only emit once per new hash so we re-prompt on a
            // genuinely new deploy, not every poll for one the user already saw.
            if (hash !== this.notifiedHash) {
              this.notifiedHash = hash;
              this.version_changed$.emit(true);
            }
          } else {
            this.currentHash = hash;
          }
        },
        (err) => {
          console.error(err, 'Could not get version');
        }
      );
    }

    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     * @param currentHash
     * @param newHash
     * @returns {boolean}
     */
    private hasHashChanged(currentHash, newHash) {
        if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
            return false;
        }

        return currentHash !== newHash;
    }
}
